import { mfaB2BRegister } from '@ytl/common-model';
import { borgAnalytics, Button, getChannel, locationReload, NumericInput, onEnter, useTheme } from '@ytl/common-web';
import { MutableRefObject, useCallback, useEffect, useRef, useState } from 'react';
import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';
import { LoginView, StageFailureType } from '../shared/@types/OpenAmStage';
import { useOpenAmStage } from '../shared/services/useOpenAmStage';

export const SmsCodeStage = () => {
  const { translation } = useLanguage();
  const { isLoading, previousStage, initParams, stage } = useOpenAm();
  //const { isLoading, previousStage, initParams } = useOpenAm();
  const [smsCode, setSmsCode] = useState('');
  const { loginWithSMSCode } = useOpenAmStage();
  const [error, setError] = useState('');
  const { isWebView } = useTheme();

  useEffect(() => {
    borgAnalytics.sendVirtualPageView({
      channel: getChannel(isWebView),
      virtualName: 'SMS Verification',
    });
  }, [isWebView]);

  const prevIsWebViewRef: MutableRefObject<any> = useRef(null);
  useEffect(() => {
    if (prevIsWebViewRef.current !== isWebView) {
      try {
        const param = (url: URL, param: string): URL => {
          return new URL(url.searchParams.has(param) ? (url.searchParams.get(param) as string) : url.toString());
        };
        const url = new URL(window.location.href);
        const goto = param(url, 'goto'); // new URL(url.searchParams.has('goto') ? (url.searchParams.get('goto') as string) : url.toString());
        console.log(goto);
        const redirect_uri = param(goto, 'redirect_uri'); //new URL(goto.searchParams.has('redirect_uri') ? (goto.searchParams.get('redirect_uri') as string) : goto.toString());
        console.log(redirect_uri);
        if (redirect_uri.pathname.endsWith(mfaB2BRegister)) {
          prevIsWebViewRef.current = isWebView;
        }
      } catch (e) {
        console.warn('cannot get redirect_uri', e);
      }
    }
  }, [isWebView]);

  const sendSmsCode = useCallback(async () => {
    try {
      await loginWithSMSCode(smsCode, failure => {
        if (failure.stagefailure === StageFailureType.SmsInvalidSmsCode) {
          borgAnalytics.sendLoginEvent({
            channel: getChannel(isWebView),
            virtualName: 'Login failed',
            method: 'sms',
            action: 'login_failed',
            result: 'true',
            reason: failure.stagefailure,
          });
          setError(translation.loginRegister.login.box.loginError.general);
        }
      });
    } catch (err) {
      borgAnalytics.sendLoginEvent({
        channel: getChannel(isWebView),
        virtualName: 'Login failed',
        method: 'sms',
        action: 'login_failed',
        result: 'true',
        reason: `${err}`,
      });
      setError(translation.loginRegister.login.box.loginError.general);
    }
  }, [smsCode, loginWithSMSCode, setError, translation, isWebView]);

  return (
    <>
      <h3>{translation.loginRegister.login.box.headerSMS}</h3>

      <div className={'login-page__sms-code-input-container-legacy'}>
        <NumericInput
          label={translation.loginRegister.login.phone.code}
          name={'smscode'}
          type={'text'}
          value={smsCode}
          onChange={e => {
            setSmsCode(e.target.value);
            setError('');
          }}
          disabled={isLoading}
          maxLength={6}
          onKeyUp={onEnter(sendSmsCode)}
        />
      </div>

      {error && <div className="login-page__container__error">{error}</div>}

      <Button
        variant={'contained'}
        onClick={sendSmsCode}
        disabled={isLoading || smsCode.length < 6}
      >
        {translation.loginRegister.login.phone.login}
      </Button>

      {/*
        {stage?.view === LoginView.SMSCodeChange2FA && (
            <p>Ez az SMSCodeChange2FA view</p>
        )}
        {previousStage?.view === LoginView.SMSCodeChange2FA && (
            <p>Az előző az SMSCodeChange2FA view volt</p>
        )} */}
      {(previousStage?.view === LoginView.SMSPhoneNumber || previousStage?.view === LoginView.SMSCode) &&
        stage?.view !== LoginView.SMSCodeChange2FA && (
          <Button
            variant={'text-undecorated'}
            onClick={() => locationReload()}
            className="login-page__container__back-button"
          >
            {initParams?.realm === 'b2c'
              ? translation.loginRegister.login.mfa.sms.backToPhoneNumber
              : translation.loginRegister.login.mfa.sms.backToLogin}
          </Button>
        )}
    </>
  );
};
